import script from "./TrainingBriefView.vue?vue&type=script&lang=ts&setup=true"
export * from "./TrainingBriefView.vue?vue&type=script&lang=ts&setup=true"

import "./TrainingBriefView.vue?vue&type=style&index=0&id=8409d6d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8409d6d8"]])

export default __exports__